import { render } from "./ExpenseList.vue?vue&type=template&id=bd58e986"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__